/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Confirm_Password_LabelInputs */



/**
* | output |
* | --- |
* | "Confirm Password" |
*
* @param {Login_Confirm_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_confirm_password_label = /** @type {((inputs?: Login_Confirm_Password_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Confirm_Password_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer le Mot de Passe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Passwort bestätigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conferma password")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердите пароль")
	if (locale === "es") return /** @type {LocalizedString} */ ("confirmar Contraseña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认密码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードを認証する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड की पुष्टि कीजिये")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirme sua senha")
	return /** @type {LocalizedString} */ ("Confirm Password")
});